const DOCUMENT_EXTENSION_PATTERN = /\.(docx|doc|dotx|dotm)$/i;
const TRAILING_VERSION_PATTERN = /[\s_-]+v?\d+$/i;

export function documentDisplayName(fileName: string): string {
  const withoutExtension = fileName.replace(DOCUMENT_EXTENSION_PATTERN, "");
  const withoutVersion = withoutExtension.replace(TRAILING_VERSION_PATTERN, "").trim();
  return withoutVersion || withoutExtension;
}
